import React from "react";
import { Modal } from "antd";

import styles from "./ModalProvizija.module.scss";
import { formatNumber } from "../../../helpers/formater";

const ModalProvizija = ({
  isModalOpen,
  setIsModalOpen,
  brutoProvizija,
  currency,
}) => {
  return (
    <Modal
      className={styles.provizija}
      title="PROVIZIJA"
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
    >
      <div className="text-center mt-20">
        <div className="text-xl font-bold text-dark-blue">
          IZNOS BRUTO PROVIZIJE:
        </div>
        <div className="text-[32px] font-black text-dark-blue mt-2">
          {formatNumber(brutoProvizija)} {currency}
        </div>
      </div>
    </Modal>
  );
};

export default ModalProvizija;
